<template>
  <div :class="{ gallery: true, 'has-mobile-filters': showMobileFilters }">
    <SearchField/>

    <button type="button" v-if="getResults.length" @click.prevent="showMobileFilters = !showMobileFilters"
            class="show-mobile-filters">
      <span>Toggle Filters</span>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256"
           height="256" viewBox="0 0 256 256" xml:space="preserve">

        <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
           transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
            <path
                d="M 85.813 59.576 H 55.575 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 30.237 c 1.657 0 3 1.343 3 3 S 87.47 59.576 85.813 59.576 z"
                style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
                transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 48.302 66.849 c -5.664 0 -10.272 -4.608 -10.272 -10.272 c 0 -5.665 4.608 -10.273 10.272 -10.273 c 5.665 0 10.273 4.608 10.273 10.273 C 58.575 62.24 53.967 66.849 48.302 66.849 z M 48.302 52.303 c -2.356 0 -4.272 1.917 -4.272 4.273 c 0 2.355 1.917 4.272 4.272 4.272 c 2.356 0 4.273 -1.917 4.273 -4.272 C 52.575 54.22 50.658 52.303 48.302 52.303 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 41.029 59.576 H 4.188 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 36.842 c 1.657 0 3 1.343 3 3 S 42.686 59.576 41.029 59.576 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 85.813 36.424 h -57.79 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 57.79 c 1.657 0 3 1.343 3 3 S 87.47 36.424 85.813 36.424 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 20.75 43.697 c -5.665 0 -10.273 -4.608 -10.273 -10.273 s 4.608 -10.273 10.273 -10.273 s 10.273 4.608 10.273 10.273 S 26.414 43.697 20.75 43.697 z M 20.75 29.151 c -2.356 0 -4.273 1.917 -4.273 4.273 s 1.917 4.273 4.273 4.273 s 4.273 -1.917 4.273 -4.273 S 23.105 29.151 20.75 29.151 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 13.477 36.424 H 4.188 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 9.289 c 1.657 0 3 1.343 3 3 S 15.133 36.424 13.477 36.424 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 57.637 13.273 H 4.188 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 53.449 c 1.657 0 3 1.343 3 3 S 59.294 13.273 57.637 13.273 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 64.909 20.546 c -5.664 0 -10.272 -4.608 -10.272 -10.273 S 59.245 0 64.909 0 c 5.665 0 10.273 4.608 10.273 10.273 S 70.574 20.546 64.909 20.546 z M 64.909 6 c -2.355 0 -4.272 1.917 -4.272 4.273 s 1.917 4.273 4.272 4.273 c 2.356 0 4.273 -1.917 4.273 -4.273 S 67.266 6 64.909 6 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 85.813 13.273 h -13.63 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 13.63 c 1.657 0 3 1.343 3 3 S 87.47 13.273 85.813 13.273 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 85.813 82.728 h -57.79 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 57.79 c 1.657 0 3 1.343 3 3 S 87.47 82.728 85.813 82.728 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 20.75 90 c -5.665 0 -10.273 -4.608 -10.273 -10.272 c 0 -5.665 4.608 -10.273 10.273 -10.273 s 10.273 4.608 10.273 10.273 C 31.022 85.392 26.414 90 20.75 90 z M 20.75 75.454 c -2.356 0 -4.273 1.917 -4.273 4.273 c 0 2.355 1.917 4.272 4.273 4.272 s 4.273 -1.917 4.273 -4.272 C 25.022 77.371 23.105 75.454 20.75 75.454 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          <path
              d="M 13.477 82.728 H 4.188 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 9.289 c 1.657 0 3 1.343 3 3 S 15.133 82.728 13.477 82.728 z"
              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;"
              transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
          </g>
          </svg>
    </button>

    <SidebarFacets/>

    <template v-if="getResults.length">
      <TypeFacets/>
      <SearchResults :results="getResults"/>

      <button type="button" v-if="false && showPagination"
              @click.prevent.stop="loadMore">Load More {{ getCurrentPage }}
      </button>
    </template>

    <div class="not-found" v-if="!getResults.length">
      <div v-if="isLoading">
        <span class="mgt-spinner rel big"></span>
      </div>
      <div v-else>
        <p>No Results found.
          <button @click="clearSearch">Clear your search params and try again?</button>
        </p>
      </div>
    </div>

    <teleport to="body">
      <transition name="mgt-popup" :duration="310">
        <MediaView
            v-if="showViewer"
            :loading="viewerIsLoading"
            :media="mediaInView"
            @close-popup="handleCloseViewer"
            @navigate="handleViewerNavigation"
        />
      </transition>
    </teleport>

  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {useRoute, useRouter} from "vue-router";

import SearchField from "@/components/search/SearchField";
import SearchResults from "@/components/search/SearchResults";
import TypeFacets from "@/components/search/TypeFacets";
import SidebarFacets from "@/components/search/SidebarFacets";
import MediaView from "@/components/viewer/MediaView";

export default {
  name: 'App',
  components: {
    SearchResults,
    SearchField,
    TypeFacets,
    SidebarFacets,
    MediaView
  },

  data() {
    return {
      showMobileFilters: true
    };
  },

  setup() {
    const router = useRouter()
    const route = useRoute()
    return {router, route};
  },

  mounted() {
    this.$store.dispatch('search/setSearchQuery', '')
  },

  computed: {
    ...mapGetters({
      showPagination: 'search/showPagination',
      getCurrentPage: 'search/getCurrentPage',
      getResults: 'search/getResults',
      isLoading: 'search/isLoading',

      showViewer: 'viewer/showViewer',
      viewerIsLoading: 'viewer/isLoading',
      mediaInView: 'viewer/inView',
    })
  },

  methods: {
    ...mapActions({
      loadMore: 'search/loadMore',
      closeViewer: 'viewer/closeEntry',
      openNextEntry: 'viewer/openNextEntry',
      openPreviousEntry: 'viewer/openPreviousEntry',
    }),

    clearSearch() {
      this.$store.dispatch('search/resetSearch');
      this.$router.push({
        name: 'mgt',
        query: {}
      });
    },

    handleCloseViewer() {
      this.closeViewer();
    },

    handleViewerNavigation(direction) {
      if (direction === 'prev') {
        this.openPreviousEntry();
      } else {
        this.openNextEntry();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/vars';
@import '@/stylesheets/spinner';

.gallery {
  @include initVars;
}

.show-mobile-filters {
  border: 1px solid #ccc;
  border-radius: 3px;
  background: none;
  font-size: 1.5em;
  padding: 0.5rem 1rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;

  svg {
    margin-left: 1rem;
    width: 1em;
    height: auto;
  }
}

@media all and (max-width: 768px) {
  .gallery > * {
    margin-bottom: 2rem;
  }

  .gallery:not(.has-mobile-filters) > .sidebar {
    display: none;
  }
}

@media all and (min-width: 768px) {
  .show-mobile-filters {
    display: none !important;
  }

  .gallery {
    display: grid;
    grid-template-columns: 25% 1fr 1fr;
    grid-template-rows: 60px 2em auto;

    gap: 1.5rem;
    grid-template-areas:
    "search-field search-field search-field"
    "sidebar type-filters type-filters"
    "sidebar results results";
  }
}

.not-found {
  grid-column-start: sidebar;
  grid-column-end: results;
  text-align: center;
  font-weight: 700;
  color: #c00;
  font-size: 1.2em;

  button {
    background: none;
    border: 1px solid #999;
    padding: .5rem 1rem;
    background: #fafafa;
    cursor: pointer;
  }
}

.gallery:deep {
  @import '../stylesheets/spinner';

  .search-field {
    grid-area: search-field;
  }

  .type-filters {
    grid-area: type-filters;
  }

  .sidebar {
    grid-area: sidebar;

    > .widget {
      margin-bottom: 1.5rem;
    }
  }

  .results {
    grid-area: results;
  }
}
</style>
